import KnowledgePageComponent from "../Components/KnowledgePage";

const KnowledgeBasePage = () => {
    return (
        <KnowledgePageComponent />
    )
}
export default KnowledgeBasePage;